import script from "./OAcordeaoProfissionais.vue?vue&type=script&lang=ts&setup=true"
export * from "./OAcordeaoProfissionais.vue?vue&type=script&lang=ts&setup=true"

import "./OAcordeaoProfissionais.vue?vue&type=style&index=0&id=c70e4356&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c70e4356"]])

export default __exports__